export function purchaseAfterScroll(current, buttonBottom, viewportTop = 0) {
  if (!Number.isFinite(buttonBottom) || !Number.isFinite(viewportTop)) return false;
  return current ? buttonBottom <= viewportTop + 8 : buttonBottom < viewportTop - 16;
}

const dock = document.getElementById('bayrak-mobile-dock');
if (dock) {
  const group = dock.querySelector('.bayrak-dock__group');
  const toolbar = dock.querySelector('.bayrak-dock__toolbar');
  const search = dock.querySelector('.bayrak-dock__search');
  const whatsapp = dock.querySelector('[data-dock-action="whatsapp"]');
  const panels = [...dock.querySelectorAll('[data-dock-panel]')];
  const live = dock.querySelector('[data-dock-live]');
  const product = JSON.parse(dock.querySelector('[data-dock-product]')?.textContent || 'null');
  const surface = document.createElement('span');
  surface.className = 'bayrak-dock__surface';
  surface.setAttribute('aria-hidden', 'true');
  group.prepend(surface);
  const motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
  const actionButtons = [...toolbar.querySelectorAll('[data-dock-action]')];
  const purchaseButtons = [...dock.querySelectorAll('[data-dock-add]')];
  const productNames = [...dock.querySelectorAll('[data-dock-product-name]')];
  const productPrices = [...dock.querySelectorAll('[data-dock-product-price]')];
  const productImages = [...dock.querySelectorAll('.bayrak-dock-product__image')];
  const stockLabel = dock.querySelector('[data-dock-stock]');
  const variantLabel = dock.querySelector('[data-dock-variant-name]');
  const purchaseSummary = dock.querySelector('.bayrak-dock-product');
  let giftConfig = null, pendingContext = null, activeContext = null, contextTimer;
  const seenContexts = new Set();
  let viewsData = null, viewsFormatter = null, viewsExpiryTimer;
  let mode = 'rest', purchase = false, compact = false, queued = false, busy = false;
  let productForm = null, addButton = null, variantLoading = false, pending = false, unconfirmed = false;
  let nativeSticky = null, quantityInput = null, header = null, collisionControls = [], previewFrames = [];
  let targetsDirty = true, productDirty = true, environmentDirty = true, geometryDirty = true, panelSizeDirty = true;
  let previewOffset = 0, maxScroll = 0, collisionRects = [], groupBounds = null, searchBounds = null;
  let nativeDialogOpen = false, keyboardHidden = false, renderedState = '', renderedPanel = null;
  let surfaceAnimation, searchAnimation, panelAnimation;
  let noticeTimer, addTimer, cartTimer, cartRequest = null, cart = null, removing = false, cartRevision = 0, cartUpdatedAt = 0;
  let nativeVersion = 0, lastScroll = scrollY, scrollDistance = 0, lastDirection = 0, lastAction = 'categories';
  const observedPreviewElements = new WeakSet();
  const previewObserver = new ResizeObserver(queueEnvironment);
  const formObserver = new MutationObserver(queueProduct);
  const nativeObserver = new MutationObserver(queueProduct);
  const geometryObserver = new ResizeObserver(queueGeometry);
  const panelObserver = new ResizeObserver(queuePanelSize);
  panels.forEach(panel => panelObserver.observe(panel));
  geometryObserver.observe(document.body);

  function setData(key, value) {
    const next = String(value);
    if (dock.dataset[key] !== next) dock.dataset[key] = next;
  }
  function attribute(node, name, value) { const next = String(value); if (node.getAttribute(name) !== next) node.setAttribute(name, next); }
  function text(node, value) { if (node.textContent !== value) node.textContent = value; }
  function inert(node, value) { if (node.inert !== value) node.inert = value; }
  function renderedMode() { return mode === 'rest' && purchase ? 'purchase' : mode; }
  function animateSurface(previous, next) {
    surfaceAnimation?.cancel();
    if (!motionPreference.matches && innerWidth <= 749 && previous?.width && next.width &&
        (Math.abs(previous.width - next.width) > .5 || Math.abs(previous.height - next.height) > .5)) {
      surfaceAnimation = surface.animate([
        { transform: `scale(${previous.width / next.width},${previous.height / next.height})` },
        { transform: 'none' }
      ], { duration: 220, easing: 'cubic-bezier(.2,.7,.2,1)' });
    }
  }
  function render() {
    const current = renderedMode();
    const previous = groupBounds && surface.getBoundingClientRect();
    const previousSearch = searchBounds && search.getBoundingClientRect();
    setData('mode', current);
    setData('compact', current === 'rest' && compact);
    for (const panel of panels) { const hidden = panel.dataset.dockPanel !== current; if (panel.hidden !== hidden) panel.hidden = hidden; inert(panel, hidden); }
    inert(toolbar, ['notice', 'context'].includes(current));
    inert(search, current !== 'rest');
    for (const button of actionButtons) {
      if (button.hasAttribute('aria-haspopup')) attribute(button, 'aria-expanded', button.dataset.dockAction === current);
      attribute(button, 'data-current', current === 'rest' && button.dataset.dockAction === 'categories');
    }
    for (const button of purchaseButtons) {
      const disabled = Boolean(!unconfirmed && (busy || variantLoading || !addButton || addButton.disabled || addButton.getAttribute("aria-busy") === "true"));
      if (button.disabled !== disabled) button.disabled = disabled;
      attribute(button, 'aria-busy', busy || variantLoading);
      const quantity = Number(quantityInput?.value || productForm?.dataset.quantityDefault || 1);
      text(button, unconfirmed ? 'Sepeti gör' : busy ? 'Ekleniyor…' : variantLoading ? 'Güncelleniyor…' : !product?.available ? (product?.variantId ? 'Tükendi' : 'Stokta yok') : addButton?.disabled ? 'Stokta yok' : `Sepete ekle${quantity > 1 ? ` (${quantity})` : ''}`);
    }
    const panel = panels.find(p => !p.hidden);
    const height = current === 'rest' ? (compact ? 48 : 60) : current === 'notice' ? 82 : current === 'purchase' ? Math.max(132, panel.offsetHeight + 82) : current === 'context' ? panel.offsetHeight + 22 : panel.offsetHeight + 82;
    const nextHeight = `${Math.ceil(height)}px`;
    if (group.style.height !== nextHeight) group.style.height = nextHeight;
    groupBounds = group.getBoundingClientRect();
    searchAnimation?.cancel();
    searchBounds = search.getBoundingClientRect();
    animateSurface(previous, groupBounds);
    if (!motionPreference.matches && current === 'rest' && previousSearch?.width && searchBounds.width && Math.abs(previousSearch.width - searchBounds.width) > .5) {
      searchAnimation = search.animate([
        { transform: `scale(${previousSearch.width / searchBounds.width})` }, { transform: 'none' }
      ], { duration: 180, easing: 'cubic-bezier(.2,.7,.2,1)' });
    }
    if (panel !== renderedPanel) {
      panelAnimation?.cancel();
      if (panel && !motionPreference.matches) panelAnimation = panel.animate([
        { opacity: 0, transform: 'translateY(5px)' }, { opacity: 1, transform: 'none' }
      ], { duration: 160, delay: current === 'purchase' ? 0 : 50, fill: 'backwards', easing: 'ease-out' });
    }
    renderedPanel = panel;
    renderedState = `${current}:${current === 'rest' && compact}`;
    panelSizeDirty = false;
  }
  function setMode(next, focus = false) {
    clearTimeout(noticeTimer); clearTimeout(contextTimer); if (mode === 'context' && next !== 'context') activeContext = null; mode = next; compact = false; render(); queueLayout();
    if (focus && next !== 'rest') requestAnimationFrame(() => panels.find(p => !p.hidden)?.querySelector('button,a')?.focus({ preventScroll: true }));
  }
  function error(message) {
    for (const node of dock.querySelectorAll('[data-dock-error]')) { node.textContent = message; node.hidden = !message; }
    if (message) live.textContent = message;
    render(); queueLayout();
  }
  function syncProduct() {
    if (!product) return;
    const nextForm = [...document.querySelectorAll('main .shopify-section--main-product product-form')].find(f => f.querySelector('[name="product-id"]')?.value === String(product.id)) || null;
    if (nextForm !== productForm) {
      productForm = nextForm;
      formObserver.disconnect();
      if (productForm) formObserver.observe(productForm, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'value', 'aria-busy'], characterData: true });
    }
    const form = productForm?.querySelector('form');
    addButton = form?.querySelector('buy-buttons button[type="submit"]') || null;
    quantityInput = form?.elements.namedItem('quantity') || null;
    const variant = product.variants.find(v => String(v.id) === String(form?.elements.namedItem('id')?.value));
    if (variant) {
      product.variantId = variant.id;
      product.available = variant.available;
      for (const node of productPrices) text(node, money(variant.price));
      if (variantLabel) text(variantLabel, variant.title === 'Default Title' ? '' : variant.title);
      for (const target of productImages) if (variant.image && target.getAttribute('src') !== variant.image) {
        target.setAttribute('src', variant.image); target.removeAttribute('srcset'); target.alt = product.title;
      }
    } else { product.variantId = ''; product.available = false; }
    for (const node of productNames) text(node, product.title);
    if (stockLabel) text(stockLabel, variantLoading ? 'Seçiminiz güncelleniyor…' : product.available ? 'Stokta' : 'Şu anda stokta yok');
    if (purchaseSummary) attribute(purchaseSummary, 'aria-label', `${product.title}, ${productPrices[0].textContent}, seçiminizi inceleyin`);
  }
  function refreshTargets() {
    targetsDirty = false;
    header = document.querySelector('header');
    const sourceWhatsApp = document.querySelector('a.custom-whatsapp[href],.custom-whatsapp a[href]');
    let whatsappReady = false;
    if (whatsapp && sourceWhatsApp) {
      try {
        const destination = new URL(sourceWhatsApp.href);
        if ((destination.protocol === 'https:' && ['wa.me', 'api.whatsapp.com', 'web.whatsapp.com'].includes(destination.hostname)) || destination.protocol === 'whatsapp:') {
          attribute(whatsapp, 'href', sourceWhatsApp.href); whatsappReady = true;
        }
      } catch { /* Keep the native contact link if its destination is unavailable. */ }
    }
    if (whatsapp) whatsapp.hidden = !whatsappReady;
    setData('whatsappReady', whatsappReady);
    document.body.dataset.bayrakDockWhatsappReady = String(whatsappReady);
    previewFrames = [...document.querySelectorAll('#PBarNextFrameWrapper,iframe[id*="preview"],#shopify-preview-bar,#ShopifyPreviewBar')];
    for (const frame of previewFrames) if (!observedPreviewElements.has(frame)) {
      observedPreviewElements.add(frame); previewObserver.observe(frame);
    }
    collisionControls = [...document.querySelectorAll('main .shopify-section--main-product buy-buttons button[type="submit"],main a.button,main shopify-accelerated-checkout')];
    if (header) geometryObserver.observe(header);
    productDirty = environmentDirty = geometryDirty = true;
  }
  function syncLayout() {
    queued = false;
    if (targetsDirty) refreshTargets();
    const productChanged = productDirty;
    if (productDirty) { productDirty = false; syncProduct(); geometryDirty = true; }
    const environmentChanged = environmentDirty;
    if (environmentDirty) {
      environmentDirty = false;
      previewOffset = 0;
      for (const frame of previewFrames) {
        const r = frame.getBoundingClientRect();
        if (r.height > 0 && r.height < 180 && Math.abs(r.bottom - innerHeight) < 5) previewOffset = Math.max(previewOffset, r.height);
      }
      const consent = document.getElementById('shopify-pc__banner');
      const consentBounds = consent?.getBoundingClientRect();
      const consentOpen = Boolean(consentBounds?.height && getComputedStyle(consent).visibility !== 'hidden');
      nativeDialogOpen = consentOpen || Boolean(document.querySelector('dialog[open],cart-drawer[open],header-search[open],header-sidebar[open],newsletter-popup[open],quick-buy-modal[open],shop-the-look-popover[open],.pswp.pswp--open'));
      const editing = document.activeElement?.matches('input:not([type="button"]):not([type="checkbox"]):not([type="radio"]),textarea,[contenteditable="true"]');
      keyboardHidden = Boolean(editing && !document.activeElement.closest('dialog') && window.visualViewport && innerHeight - visualViewport.height > 160);
    }
    const original = addButton?.getBoundingClientRect();
    if (geometryDirty) {
      geometryDirty = false;
      maxScroll = Math.max(0, document.scrollingElement.scrollHeight - document.scrollingElement.clientHeight);
      collisionRects = collisionControls.filter(control => control !== addButton && control.isConnected).map(control => {
        const r = control.getBoundingClientRect();
        return { top: r.top + scrollY, bottom: r.bottom + scrollY, left: r.left, right: r.right, width: r.width, height: r.height };
      });
    }
    if (product && productForm && original?.width && original?.height) {
      // A button below the first viewport has not been passed yet.
      purchase = purchaseAfterScroll(purchase, original.bottom, window.visualViewport?.offsetTop || 0);
    } else purchase = false;
    const productTopHidden = Boolean(product && !purchase);
    setData('productTopHidden', productTopHidden);
    if (productTopHidden && mode !== 'rest') setMode('rest');
    const previewValue = `${previewOffset}px`;
    if (document.body.style.getPropertyValue('--bayrak-preview-offset') !== previewValue) document.body.style.setProperty('--bayrak-preview-offset', previewValue);
    maybeShowContext();
    const current = renderedMode();
    if (productChanged || environmentChanged || panelSizeDirty || renderedState !== `${current}:${current === 'rest' && compact}`) render();
    const regions = current === 'rest' ? [groupBounds, searchBounds] : [groupBounds];
    const controls = collisionRects.map(r => ({ ...r, top: r.top - scrollY, bottom: r.bottom - scrollY }));
    if (original) controls.push(original);
    const overlaps = ['rest', 'purchase'].includes(current) && controls.some(r =>
      r.width > 0 && r.height > 0 && regions.some(d => d && r.top < d.bottom && r.bottom > d.top && r.left < d.right && r.right > d.left));
    setData('modalHidden', nativeDialogOpen);
    document.body.dataset.bayrakDockModalHidden = String(nativeDialogOpen);
    setData('keyboardHidden', keyboardHidden);
    setData('purchaseHidden', overlaps);
    inert(dock, innerWidth > 749 || productTopHidden || nativeDialogOpen || keyboardHidden || overlaps);
  }
  function queueLayout() { if (!queued) { queued = true; requestAnimationFrame(syncLayout); } }
  function queueProduct() { productDirty = true; queueLayout(); }
  function queueEnvironment() { environmentDirty = geometryDirty = true; queueLayout(); }
  function queueGeometry() { geometryDirty = true; queueLayout(); }
  function queuePanelSize() { panelSizeDirty = true; queueLayout(); }
  function queueTargets() { targetsDirty = true; queueLayout(); }
  function money(amount) { const currency = cart?.currency || product?.currency || Shopify.currency?.active || 'TRY'; return currency === 'TRY' ? `${new Intl.NumberFormat('tr-TR', { minimumFractionDigits: amount % 100 ? 2 : 0, maximumFractionDigits: amount % 100 ? 2 : 0 }).format(amount / 100)} TL` : new Intl.NumberFormat(document.documentElement.lang || 'tr-TR', { style: 'currency', currency }).format(amount / 100); }
  function renderViews() {
    const label = viewsFormatter?.(viewsData, dock.dataset.productHandle) || '';
    for (const node of dock.querySelectorAll('[data-dock-views]')) {
      text(node, label); node.hidden = !label;
      if (label) node.title = `Güncelleme: ${new Intl.DateTimeFormat('tr-TR', { timeZone: viewsData.timeZone, day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit' }).format(new Date(viewsData.generatedAt))}`;
    }
    panelSizeDirty = true; queueLayout();
  }
  async function loadViews() {
    if (!product || innerWidth > 749 || !dock.dataset.viewsUrl) return;
    try {
      const [module, response] = await Promise.all([
        import(dock.dataset.viewsModule),
        fetch(dock.dataset.viewsUrl, { credentials: 'omit', cache: 'no-cache', signal: AbortSignal.timeout(5000) })
      ]);
      if (!response.ok) return;
      viewsData = await response.json(); viewsFormatter = module.productViewLabel;
      renderViews();
      const expiry = Math.min(Date.parse(viewsData.expiresAt), Date.parse(`${viewsData.today}T21:00:00Z`));
      if (Number.isFinite(expiry) && expiry > Date.now()) {
        clearTimeout(viewsExpiryTimer); viewsExpiryTimer = setTimeout(renderViews, Math.min(2147483647, expiry - Date.now() + 50));
      }
    } catch { /* Analytics is optional; all shopping controls remain available. */ }
  }
  if (product && innerWidth <= 749) setTimeout(() => { void loadViews(); }, 8000);
  document.addEventListener('visibilitychange', () => { if (!document.hidden && viewsData) renderViews(); });
  function renderCount(count) {
    if (!Number.isInteger(count) || count < 0) return;
    const badge = dock.querySelector('[data-dock-count]'); badge.textContent = String(count); badge.hidden = count === 0;
    toolbar.querySelector('[data-dock-action="cart"]').setAttribute('aria-label', count ? `Sepet, ${count} ürün` : 'Sepet');
  }
  function renderCart() {
    if (!cart) return;
    renderCount(cart.item_count);
    const container = dock.querySelector('[data-dock-cart-items]');
    const fragment = document.createDocumentFragment();
    for (const item of cart.items) {
      const row = document.createElement('div'); row.className = 'bayrak-dock-cart-item';
      if (item.image) { const image = document.createElement('img'); image.src = item.image; image.alt = ''; image.width = 44; image.height = 58; row.append(image); }
      const copy = document.createElement('div'); copy.className = 'bayrak-dock-cart-item__copy';
      const link = document.createElement('a'); link.href = item.url; link.textContent = item.product_title; copy.append(link);
      const detail = document.createElement('small'); detail.textContent = `${item.variant_title && item.variant_title !== 'Default Title' ? `${item.variant_title} · ` : ''}${item.quantity} × ${money(item.final_price)}`; copy.append(detail);
      row.append(copy);
      const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'bayrak-dock__close'; remove.dataset.dockRemove = item.key; remove.setAttribute('aria-label', `${item.product_title} ürününü kaldır`); remove.textContent = '×'; remove.disabled = removing; row.append(remove); fragment.append(row);
    }
    container.replaceChildren(fragment);
    const message = dock.querySelector('[data-dock-cart-message]'); message.textContent = cart.item_count ? '' : 'Sepetiniz boş'; message.hidden = cart.item_count > 0;
    dock.querySelector('[data-dock-cart-total]').hidden = cart.item_count === 0;
    dock.querySelector('[data-dock-cart-subtotal]').textContent = money(cart.total_price);
    const checkout = dock.querySelector('[data-dock-checkout]'); checkout.hidden = cart.item_count === 0; checkout.inert = removing; checkout.setAttribute('aria-disabled', String(removing));
    updateGiftGoal();
    render(); queueLayout();
  }
  async function refreshCart() {
    if (cartRequest) return cartRequest;
    const revision = cartRevision;
    cartRequest = (async () => {
      const response = await fetch(`${dock.dataset.cartUrl}.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(8000) });
      if (!response.ok) throw Error('Sepet yüklenemedi. Devam etmek için sepeti açın.');
      const result = await response.json();
      if (revision === cartRevision) { cart = result; cartUpdatedAt = Date.now(); renderCart(); }
      return cart;
    })();
    try { return await cartRequest; } finally { cartRequest = null; }
  }
  async function openCart() {
    setMode('cart', true);
    if (cart && Date.now() - cartUpdatedAt < 5000) { renderCart(); return; }
    const message = dock.querySelector('[data-dock-cart-message]');
    try { await refreshCart(); } catch (e) { message.textContent = e.message; message.hidden = false; render(); }
  }
  function nativeTarget(kind) {
    if (kind === 'cart') return document.getElementById('cart-drawer');
    const control = document.querySelector('header a[aria-controls^="header-search-"]');
    return control && document.getElementById(control.getAttribute('aria-controls'));
  }
  async function openNative(kind) {
    const version = ++nativeVersion;
    const target = nativeTarget(kind);
    if (typeof target?.show !== 'function') return false;
    setMode('rest');
    for (const other of [nativeTarget('cart'), nativeTarget('search')]) if (other !== target && other?.open && typeof other.hide === 'function') await other.hide();
    if (version === nativeVersion && !target.open) void target.show();
    queueEnvironment(); return true;
  }
  async function removeItem(key) {
    if (removing) return;
    removing = true; let failure = ''; renderCart();
    try {
      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
      const response = await fetch(`${dock.dataset.cartUrl}/change.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: 0, sections, sections_url: location.pathname }) });
      const result = await response.json();
      if (!response.ok || result.status) throw Error(result.description || 'Sepet güncellenemedi. Yeniden deneyin.');
      cart = result; document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'line-item:change', cart } }));
    } catch (e) { failure = e.message; }
    finally { removing = false; if (cart) renderCart(); if (failure) { const message = dock.querySelector('[data-dock-cart-message]'); message.textContent = failure; message.hidden = false; render(); } }
  }
  function verifiedGift(gift, resource = cart) {
    return Boolean(resource?.items?.some(item => item.properties?._luna_free_gift === gift.type && item.quantity > 0 && item.final_price === 0));
  }
  function updateGiftGoal() {
    const node = dock.querySelector('[data-dock-gift-goal]');
    if (!node) return;
    if (!giftConfig || !cart?.item_count) { node.hidden = true; return; }
    const total = Number(giftConfig.eligibleCents || 0);
    const tiers = [
      { type: 'flower', available: giftConfig.flowerAvailable, threshold: Number(giftConfig.flowerThreshold), label: 'Atma çiçeği' },
      { type: 'veil', available: giftConfig.veilAvailable, threshold: Number(giftConfig.veilThreshold), label: 'Duvak' }
    ].filter(t => t.available && t.threshold > 0);
    const next = tiers.find(t => total < t.threshold);
    const outstanding = tiers.filter(t => total >= t.threshold && !verifiedGift(t));
    const earned = tiers.filter(t => verifiedGift(t));
    if (!next && !outstanding.length && !earned.length) { node.hidden = true; return; }
    node.hidden = false;
    text(node.querySelector('[data-dock-gift-goal-label]'), next ? `${next.label} hediyesi için ${money(next.threshold - total)} kaldı.` : outstanding.length ? 'Hediyen sepete hazırlanıyor…' : earned.length > 1 ? 'Çiçek ve duvak hediyelerin sepette.' : 'Ücretsiz hediyen sepette.');
    node.querySelector('[data-dock-gift-goal-bar]').style.transform = `scaleX(${next ? Math.min(1, Math.max(0, total / next.threshold)) : 1})`;
  }
  function maybeShowContext() {
    if (activeContext && !activeContext.gifts.every(g => verifiedGift(g))) { setMode('rest'); return; }
    if (!pendingContext) return;
    if (pendingContext.expires < Date.now() || !pendingContext.gifts.every(g => verifiedGift(g))) { pendingContext = null; return; }
    if (innerWidth > 749 || (product && !purchase) || nativeDialogOpen || keyboardHidden || busy || !['rest', 'notice'].includes(mode) || document.activeElement?.matches('input,textarea,[contenteditable="true"]') || (dock.contains(document.activeElement) && document.activeElement.matches(':focus-visible'))) return;
    activeContext = pendingContext; pendingContext = null;
    const gifts = activeContext.gifts;
    const media = dock.querySelector('[data-dock-context-media]'); media.replaceChildren();
    for (const gift of gifts) if (gift.image) {
      const img = document.createElement('img'); img.src = gift.image; img.alt = ''; img.width = 42; img.height = 50; media.append(img);
    }
    const title = gifts.length > 1 ? 'İki hediyen sepette' : gifts[0].type === 'flower' ? 'Atma çiçeğin sepette' : 'Duvağın sepette';
    text(dock.querySelector('[data-dock-context-title]'), title);
    text(dock.querySelector('[data-dock-context-description]'), gifts.length > 1 ? 'Atma çiçeği ve kristal işlemeli duvak.' : 'Ücretsiz hediyen otomatik eklendi.');
    setMode('context'); live.textContent = title;
    const dismiss = () => {
      if (mode !== 'context') return;
      if ((matchMedia('(hover: hover)').matches && dock.matches(':hover')) || (dock.contains(document.activeElement) && document.activeElement.matches(':focus-visible')) || nativeDialogOpen || keyboardHidden) { contextTimer = setTimeout(dismiss, 1200); return; }
      setMode('rest');
    };
    contextTimer = setTimeout(dismiss, 5600);
  }
  document.addEventListener('luna-gifts:state', event => {
    giftConfig = event.detail?.config || null;
    if (event.detail?.cart?.items) { cart = event.detail.cart; cartUpdatedAt = Date.now(); }
    updateGiftGoal(); queueLayout();
  });
  document.addEventListener('bayrak-dock:gift', event => {
    const gifts = event.detail?.gifts;
    if (innerWidth > 749 || !Array.isArray(gifts) || !gifts.length || !gifts.every(g => ['flower', 'veil'].includes(g.type) && verifiedGift(g, event.detail.cart))) return;
    event.preventDefault();
    giftConfig = event.detail.config;
    cart = event.detail.cart; cartUpdatedAt = Date.now();
    const key = gifts.map(g => g.type).sort().join(':');
    if (seenContexts.has(key)) return;
    seenContexts.add(key);
    pendingContext = { gifts, expires: Date.now() + 120000 };
    queueLayout();
  });
  function finishAdd(message = '') {
    clearTimeout(addTimer); pending = false; busy = false; error(message); queueLayout();
  }
  function addProduct() {
    if (unconfirmed) { void openCart(); return; }
    if (busy || variantLoading || !addButton || addButton.disabled || addButton.getAttribute("aria-busy") === "true") return;
    const form = productForm.querySelector('form');
    if (!form?.reportValidity()) { productForm.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    if (typeof customElements.get('product-form') !== 'function' || addButton.getAttribute('aria-busy') === 'true') return;
    pending = true; busy = true; error(''); render();
    form.requestSubmit(addButton);
    addTimer = setTimeout(() => { if (pending) { unconfirmed = true; finishAdd('Yeniden denemeden önce sepetinizi kontrol edin.'); } }, 15000);
  }
  dock.addEventListener('click', event => {
    const target = event.target.closest('a,button'); if (!target) return;
    if (target.hasAttribute('data-dock-context-action')) { void openCart(); return; }
    if (target.hasAttribute('data-dock-add')) { event.preventDefault(); addProduct(); return; }
    if (target.hasAttribute('data-dock-remove')) { void removeItem(target.dataset.dockRemove); return; }
    if (target.hasAttribute('data-dock-close')) {
      setMode('rest'); requestAnimationFrame(() => (purchase ? dock.querySelector('[data-dock-add]') : toolbar.querySelector(`[data-dock-action="${lastAction}"]`))?.focus({ preventScroll: true })); return;
    }
    if (target.hasAttribute('data-dock-options')) { setMode('rest'); productForm?.closest('.shopify-section')?.querySelector('variant-picker')?.scrollIntoView({ behavior: motionPreference.matches ? 'auto' : 'smooth', block: 'center' }); return; }
    const action = target.dataset.dockAction;
    if (action === 'categories') { nativeVersion++; lastAction = action; setMode(mode === action ? 'rest' : action, mode !== action); }
    if (action === 'product') { lastAction = 'categories'; setMode('product', true); }
    if (action === 'cart') { event.preventDefault(); lastAction = action; if (mode === 'cart') setMode('rest'); else void openCart(); }
    if (action === 'search' || action === 'native-cart') {
      const kind = action === 'native-cart' ? 'cart' : 'search';
      const controller = nativeTarget(kind);
      if (typeof controller?.show === 'function') { event.preventDefault(); void openNative(kind); }
    }
  });
  document.addEventListener('cart:change', event => {
    cartRevision++;
    const resource = event.detail?.cart;
    if (resource?.items) { cart = resource; cartUpdatedAt = Date.now(); renderCart(); }
    queueProduct();
  });
  document.addEventListener('cart:refresh', () => {
    cartRevision++; cartUpdatedAt = 0;
    clearTimeout(cartTimer);
    cartTimer = setTimeout(async () => { try { if (cartRequest) await cartRequest; await refreshCart(); } catch {} }, 120);
  });
  document.addEventListener('variant:add', event => {
    if (!pending || event.target !== productForm?.querySelector('form')) return;
    unconfirmed = false; finishAdd(); setMode('notice'); live.textContent = 'Sepete eklendi';
    noticeTimer = setTimeout(() => { if (mode === 'notice' && !dock.querySelector('[data-dock-panel="notice"]').contains(document.activeElement)) setMode('rest'); }, 2400);
  });
  document.addEventListener('cart:error', event => { if (pending && event.target === productForm?.querySelector('form')) finishAdd(String(event.detail?.error || 'Ürün eklenemedi. Yeniden deneyin.')); });
  document.addEventListener('change', event => {
    if (event.target.matches('input[data-option-position]') && event.target.form === productForm?.querySelector('form')) { variantLoading = true; error(''); queueProduct(); }
    if (event.target.name === 'quantity' && event.target.form === productForm?.querySelector('form')) queueProduct();
  });
  document.addEventListener('variant:change', event => {
    if (event.target !== productForm?.querySelector('form')) return;
    const variant = event.detail?.variant;
    if (variant) {
      const stored = product.variants.find(v => String(v.id) === String(variant.id));
      if (stored) Object.assign(stored, { price: variant.price, available: variant.available });
    }
    variantLoading = false; unconfirmed = false; error(''); queueTargets();
  });
  document.addEventListener('product:rerender', queueTargets, true);
  document.addEventListener('input', event => { if (event.target.name === 'quantity') queueProduct(); });
  document.addEventListener('pointerdown', event => { if (mode !== 'rest' && !dock.contains(event.target)) setMode('rest'); }, { passive: true });
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && mode !== 'rest') { setMode('rest'); (purchase ? dock.querySelector('[data-dock-add]') : toolbar.querySelector(`[data-dock-action="${lastAction}"]`))?.focus({ preventScroll: true }); } });
  for (const name of ['dialog:before-show', 'dialog:after-show', 'dialog:before-hide', 'dialog:after-hide', 'toggle', 'focusin', 'focusout', 'visitorConsentCollected', 'shopify:section:load']) document.addEventListener(name, queueEnvironment, true);
  window.addEventListener('scroll', () => {
    const position = Math.max(0, Math.min(scrollY, maxScroll));
    const delta = position - lastScroll; lastScroll = position;
    const direction = Math.sign(delta);
    if (Math.abs(delta) >= 1) {
      if (direction !== lastDirection) scrollDistance = 0;
      lastDirection = direction; scrollDistance += Math.abs(delta);
    }
    if (position < 60) compact = false;
    else if (scrollDistance >= 44) { compact = direction > 0; scrollDistance = 0; }
    queueLayout();
  }, { passive: true });
  window.addEventListener('resize', queueEnvironment, { passive: true });
  window.visualViewport?.addEventListener('resize', queueEnvironment, { passive: true });
  motionPreference.addEventListener('change', () => {
    if (motionPreference.matches) { surfaceAnimation?.cancel(); searchAnimation?.cancel(); panelAnimation?.cancel(); }
  });
  const targetSelector = 'product-form,atelier-sticky,product-sticky-bar,header,dialog,cart-drawer,header-search,header-sidebar,newsletter-popup,quick-buy-modal,#shopify-pc__banner,.custom-whatsapp,a.button,shopify-accelerated-checkout,#PBarNextFrameWrapper,iframe[id*="preview"],#shopify-preview-bar,#ShopifyPreviewBar';
  new MutationObserver(records => {
    if (records.some(record => !dock.contains(record.target) && [...record.addedNodes, ...record.removedNodes].some(node =>
      node.nodeType === Node.ELEMENT_NODE && (node.matches(targetSelector) || node.querySelector(targetSelector))))) queueTargets();
  }).observe(document.body, { childList: true, subtree: true });
  new MutationObserver(records => {
    if (records.some(r => r.target.matches?.('dialog,cart-drawer,header-search,header-sidebar,newsletter-popup,quick-buy-modal,#shopify-pc__banner,.pswp'))) queueEnvironment();
  }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open', 'hidden', 'aria-hidden', 'style', 'class'] });
  window.addEventListener('pageshow', () => { queueTargets(); cartUpdatedAt = 0; });
  document.body.dataset.bayrakDockReady = 'true';
  syncLayout();
}
